import cn from "classnames";
import React from "react";
import { NavLink as RouterNavLink } from "react-router-dom";
import s from "./nav-link.module.scss";

const NavLink = ({
  disabled,
  style,
  className,
  activeClassName,
  children,
  to,
  onClick,
  ...rest
}) => {
  return (
    <RouterNavLink
      to={to}
      style={style}
      disabled={disabled}
      className={cn(s.navLink, className)}
      activeClassName={cn(s.active, activeClassName)}
      onClick={onClick}
      children={children}
      {...rest}
    />
  );
};

export default NavLink;
